const doc = [({"ko":({"adminLabelActivity":({"facilityName":"시설명"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;